module.exports = __webpack_public_path__ + "img/54.9bafe9e5.jpg";